import React from 'react';
import { Icon, Breadcrumbs, Hidden } from '@material-ui/core';
import { NavLink } from 'react-router-dom';


const Breadcrumb = ({ routeSegments, isCapitalize = true }) => {
  return (
    <div className="flex flex-wrap items-center mt-10 mx-10">
      {routeSegments ? (
        <Hidden xsDown>
          <h4 className={`m-0 pb-1px text-20 text-brand ${isCapitalize === true ? 'capitalize' : ''} align-middle`} >
            {routeSegments[routeSegments.length - 1]['name']}
          </h4>
          <h4 className="m-0 pb-3px ml-2 text-light-gray">|</h4>
        </Hidden>
      ) : null}
      <Breadcrumbs
        separator={<Icon className="text-light-gray">navigate_next</Icon>}
        className="flex items-center relative"
      >
        <NavLink to="/">
          <Icon className="align-middle ml-3" color="primary">
            home
          </Icon>
        </NavLink>
        {routeSegments
          ? routeSegments.map((route, index) => {
            return index !== routeSegments.length - 1 && route.path ? (
              <NavLink key={index} to={route.path}>
                <span className={`${isCapitalize === true ? 'capitalize' : ''} text-light-gray`}>
                  {route.name}
                </span>
              </NavLink>
            ) : (
              <span
                key={index}
                className={`${isCapitalize === true ? 'capitalize' : ''} text-light-gray`}
              >
                {route.name}
              </span>
            );
          })
          : null}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;
